export class StringErrorUtility {

    public static hasNoInvalidCharacter(testString: string, invalidCharacterSet: Array<string>): boolean {
        for (const i of invalidCharacterSet) {
            if (testString.indexOf(i) !== -1) {
                return false;
            }
        }
        return true;
    }

    public static hasNoDuplicates(testString: string, possibleDuplicates: Array<string>, caseSensitiveAndTrimmed: boolean = false): boolean {
        return caseSensitiveAndTrimmed ? StringErrorUtility.hasNoDuplicatesCaseInsensitiveTrimmed(testString, possibleDuplicates) : possibleDuplicates.indexOf(testString) === -1;
    }

    public static isNotStartingWithSpace(testString: string) {
        return (!testString) || testString && testString[0] !== ' ';
    }

    public static isContainingLessThanLimitedCharacters(testString: string, limit: number) {
        return testString.length <= limit;
    }

    public static isNotEmptyString(testString: string) {
        return testString !== undefined && testString !== null && testString.length > 0;
    }

    private static hasNoDuplicatesCaseInsensitiveTrimmed(testString: string, possibleDuplicates: Array<string>): boolean {
        for (const d of possibleDuplicates) {
            if (testString.trim().toLowerCase() === d.trim().toLowerCase()) {
                return false;
            }
        }
        return true;
    }
}
